import type UnassignedShifts from 'modules/shift_management/store/internal/collections/UnassignedShifts'
import type UnassignedShift from 'modules/shift_management/store/internal/models/UnassignedShift'

export type UnassignedShiftsState = UnassignedShift[]

export type UnassignedShiftsDispatch = (arg0: UnassignedShiftsAction) => void

export type UnassignedShiftsAction =
  | {
      type: 'BOOTSTRAP'
      unassignedShifts: UnassignedShifts | undefined
    }
  | {
      type: 'ADD_UNASSIGNED_SHIFTS'
      unassignedShifts: UnassignedShift[]
    }
  | {
      type: 'EDIT_UNASSIGNED_SHIFT'
      unassignedShift: UnassignedShift
    }
  | {
      type: 'DESTROY_UNASSIGNED_SHIFT'
      unassignedShift: UnassignedShift
    }

export function initialUnassignedShiftsState(): UnassignedShiftsState {
  return []
}

export default function reducer(
  state: UnassignedShiftsState,
  action: UnassignedShiftsAction
): UnassignedShiftsState {
  switch (action.type) {
    case 'BOOTSTRAP': {
      if (!!action.unassignedShifts) {
        return action.unassignedShifts.all
      }
      return state
    }
    case 'ADD_UNASSIGNED_SHIFTS': {
      return state.concat(action.unassignedShifts)
    }
    case 'EDIT_UNASSIGNED_SHIFT': {
      return state.map((unassignedShift) => {
        return unassignedShift.id === action.unassignedShift.id
          ? action.unassignedShift
          : unassignedShift
      })
    }
    case 'DESTROY_UNASSIGNED_SHIFT': {
      return state.filter((unassignedShift) => unassignedShift.id !== action.unassignedShift.id)
    }
    default:
      return state
  }
}
